import script from "./Configure.vue?vue&type=script&setup=true&lang=js"
export * from "./Configure.vue?vue&type=script&setup=true&lang=js"

import "./Configure.vue?vue&type=style&index=0&id=20f19f91&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20f19f91"]])

export default __exports__